import { render, staticRenderFns } from "./YwArtificialPatrolTaskDetailForm.vue?vue&type=template&id=3c9828f0&"
import script from "./YwArtificialPatrolTaskDetailForm.vue?vue&type=script&lang=js&"
export * from "./YwArtificialPatrolTaskDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports